import { useParams } from 'react-router-dom';
import { Stack, Typography } from '../../ui/core';
import { cardBodySx } from '../../ui/styles';
import { classifyRideId, RideIdKind } from './rideId';
import ConfirmedRideDetails from './ConfirmedRideDetails';
import StandbyRideDetails from './StandbyRideDetails';

/**
 * /rides/:id serves two id spaces, so this decides which one it is looking at
 * before anything fetches.
 *
 * Classifying up front — rather than trying /admin/ride and interpreting the
 * failure — is what makes the standby case work at all: a UUID sent there is
 * rejected by @IsMongoId() with a 400, and the page used to render that as a
 * generic "Unable to load ride". It also means the ride-events request can
 * never fire with a standby id, so there is no spurious event-log error toast.
 */
const RideDetails = () => {
  const { id } = useParams();
  const kind = classifyRideId(id);

  if (kind === RideIdKind.confirmed) {
    return <ConfirmedRideDetails id={id} />;
  }

  if (kind === RideIdKind.standby) {
    return <StandbyRideDetails id={id} />;
  }

  return (
    <Stack sx={cardBodySx} alignItems="center" justifyContent="center" spacing="8px">
      <Typography variant="h5">Not a ride id</Typography>
      <Typography color="text.secondary">
        “{id}” is neither a ride id nor a standby ride request id, so there is nothing to look up.
      </Typography>
    </Stack>
  );
};

export default RideDetails;
